import React from "react";
import Upload from "./pages/Upload";

function App() {
  return <Upload />;
}

export default App;
